const React = require('react');
const {default: TextArea} = require('@material-ui/core/TextareaAutosize');
const inputCtor = require('../../utils/inputCtor');
const LabelDisplay = require("../LabelDisplay");
const ErrorDisplay = require("../ErrorDisplay");

const Input = ({
  id,
  name,
  type,
  onChange,
  value,
  disabled,
  showError
}) => (
  <TextArea
    id={id}
    name={name}
    type={type || 'text'}
    onChange={(e) => onChange(name, e.target.value)}
    value={value || ''}
    disabled={disabled}
    margin="none"
    variant="standard"
    className={`
      dB w hmin132 b1 bs bc0 r9
      p25 bxzBB f12 fw7 ff$3
      olNone rszNone dn
      bc0:f (bcF00).error
      ` + (showError ? ' error' : '')
    }
    minRows={1}
    maxRows={1}
  />
);

const Countdown = ({value, maxLength}) => {
  const valueLength = value ? value.length : '0';

  return maxLength ? (
    <div
      className={`dF fhaE mr10 o50 f12 (o100|cF00).overflow`
        + (valueLength > maxLength ? ' overflow' : '')}
    >
      {valueLength}
      {maxLength && `/${maxLength}`}
    </div>
  ) : null;
}

const Component = ({
  className,
  labelProps,
  inputProps,
  errorProps,
  maxLength
}) => (
  <div
    className={'rlv ' + (className || '')}
  >
    <LabelDisplay {...labelProps} />
    <Input {...inputProps} />
    <Countdown value={inputProps.value} maxLength={maxLength} />
    <ErrorDisplay {...errorProps} />
  </div>
)

module.exports = inputCtor(Component)
